// Sesión local del inspector de Modo Auditor (2026-09-09) — espejo de
// hceAdminSession.ts, pero en `sessionStorage`, no `localStorage`: es la
// credencial de un dispositivo PRESTADO durante una visita puntual, tiene
// que morir sola al cerrar la pestaña, no sobrevivir a la próxima vez que
// alguien abra el navegador en ese mismo equipo.
const AUDITOR_TOKEN_KEY = 'hce-auditor-token';
const AUDITOR_EXP_KEY = 'hce-auditor-exp';
const AUDITOR_SESION_ID_KEY = 'hce-auditor-sesion-id';

/**
 * El token es `base64url(payload).firma` — la firma es lo que lo hace
 * infalsificable, no el payload, así que decodificarlo del lado del
 * navegador (sin la llave de firma) es seguro: solo lee `exp`/`sesionId`
 * para pintar la cuenta regresiva y saber qué id cerrar, nunca lo valida
 * acá (el servidor revalida la firma en cada request de todos modos).
 */
function decodificarTokenAuditor(token: string): { sesionId: number; exp: number } | null {
  try {
    const [body] = token.split('.');
    if (!body) return null;
    const normalizado = body.replace(/-/g, '+').replace(/_/g, '/');
    const conRelleno = normalizado + '='.repeat((4 - (normalizado.length % 4)) % 4);
    const payload = JSON.parse(atob(conRelleno));
    if (typeof payload?.exp !== 'number' || typeof payload?.sesionId !== 'number') return null;
    return { sesionId: payload.sesionId, exp: payload.exp };
  } catch {
    return null;
  }
}

/** `false` si el token no se pudo decodificar (no debería pasar con un token real recién emitido). */
export function guardarSesionAuditor(token: string): boolean {
  const decodificado = decodificarTokenAuditor(token);
  if (!decodificado) return false;
  sessionStorage.setItem(AUDITOR_TOKEN_KEY, token);
  sessionStorage.setItem(AUDITOR_EXP_KEY, String(decodificado.exp));
  sessionStorage.setItem(AUDITOR_SESION_ID_KEY, String(decodificado.sesionId));
  return true;
}

export function leerSesionAuditor(): { token: string; exp: number; sesionId: number } | null {
  const token = sessionStorage.getItem(AUDITOR_TOKEN_KEY);
  const exp = Number(sessionStorage.getItem(AUDITOR_EXP_KEY));
  const sesionId = Number(sessionStorage.getItem(AUDITOR_SESION_ID_KEY));
  if (!token || !Number.isFinite(exp) || !Number.isFinite(sesionId)) return null;
  if (exp < Date.now()) {
    cerrarSesionAuditor();
    return null;
  }
  return { token, exp, sesionId };
}

export function cerrarSesionAuditor(): void {
  sessionStorage.removeItem(AUDITOR_TOKEN_KEY);
  sessionStorage.removeItem(AUDITOR_EXP_KEY);
  sessionStorage.removeItem(AUDITOR_SESION_ID_KEY);
}
